module.exports = __webpack_public_path__ + "static/media/1.935de977.png";